import { useTranslation } from 'react-i18next';

import { formatCurrency } from 'support/helpers/currency/currency';
import { calculateTaxAmountForOrderedProduct, OrderFormValue } from 'support/helpers/orderForms/orderForms';
import { OrderFormProductDTO } from 'support/types';

type OrderTaxesProps = {
  currency: string | undefined;
  orderedProducts: Record<string, OrderFormValue>;
  productsData: Record<string, OrderFormProductDTO>;
};

export function OrderTaxes({ currency, orderedProducts, productsData }: OrderTaxesProps) {
  const { t } = useTranslation();
  const taxBreakdown = Object.entries(orderedProducts).reduce<
    Record<number, { productCount: number; totalTax: number }>
  >((acc, [productId, ordered]) => {
    const product = productsData[productId];
    if (!product?.tax_rate) {
      return acc;
    }

    const taxRate = product.tax_rate;
    const taxAmount = calculateTaxAmountForOrderedProduct(ordered, product);

    if (!acc[taxRate]) {
      acc[taxRate] = {
        productCount: 0,
        totalTax: 0,
      };
    }

    acc[taxRate].productCount += 1;
    acc[taxRate].totalTax += taxAmount;

    return acc;
  }, {});

  return (
    <>
      {Object.entries(taxBreakdown).map(([taxRate, { productCount, totalTax }]) => (
        <div key={taxRate} className="flex items-center justify-between">
          <dt className="text-xs font-normal leading-4 text-gray-500">
            {t('orderForms:checkout.taxDetail', { taxRate, count: productCount })}
          </dt>
          <dd className="text-xs font-medium leading-4 text-gray-700">+ {formatCurrency(totalTax, currency)}</dd>
        </div>
      ))}
    </>
  );
}
